<template>
  <div 
    v-if="brandConfig"
    class="main-screen" 
    :style="{ 'background-image': `url(${brandConfig.brandImage('background', 'img-vch-background', 'jpeg')})`}"
  >
    <div class="layout-wrapper row full-width full-height items-center">
      <q-card flat class="voucher-box shadow-24 scroll">
        <q-card-section class="text-center">
          <div v-if="!showDialog">
            <span class="text-h2 vch-title">Colaboradores</span>
          </div>
        </q-card-section>

        <q-card-section class="col text-center flex flex-center q-px-lg">
          <Transition name="scale" mode="out-in">
            <div v-if="!showDialog" class="full-width" key="form-section">
              <div class="vch-instruction text-grey-10">
                Esta página é exclusiva para você, colaborador!
                Oferecemos um desconto especial para comprar o produto que
                escolher e receber no endereço de sua preferência.
                Para isso digite seu CPF no campo abaixo e após a validação
                será informado o código de cupom-desconto.
              </div>

              <div class="q-px-lg">
                <q-input
                  v-model="cpf"
                  mask="###.###.###-##"
                  placeholder="Digite seu CPF"
                  borderless
                  input-class="text-center"
                  class="vch-input-line q-mt-md"
                  @keydown.enter.prevent="handleConfirm"
                />
                
                <div class="error-spacer">
                  <transition name="q-transition--fade">
                    <div v-if="getAlert" class="text-negative text-caption text-weight-bold">
                      {{ getAlert.message || getAlert }}
                    </div>
                  </transition>
                </div>

                <q-btn
                  label="Confirmar"
                  unelevated
                  class="vch-btn-confirm full-width"
                  :loading="isLoading"
                  @click="handleConfirm"
                />
              </div>
            </div>

            <div v-else-if="employee" class="full-width" key="success-section">
              <q-icon name="check_circle_outline" :style="{ color: brandConfig.brandColor() }" size="80px" />            
              <p class="text-h5 text-weight-bolder">Funcionário cadastrado!</p>
              
              <div class="text-body1 q-mt-md">
                  Olá <strong>{{ employee.nome }}</strong>. 
                  Você garantiu <strong>{{ employee.desconto }}% de desconto!</strong>
                  Escolha seus produtos e utilize o cupom que foi enviado ao e-mail:
                  <div class="text-subtitle1 text-weight-bolder q-my-md break-all">
                    {{ employee.email }}
                  </div>
              </div>

              <div class="text-body2 q-pa-md">
                Em até 15 minutos, seu voucher estará
                disponível. Aguarde e aproveite!
              </div>

              <q-btn
                label="IR PARA A LOJA"
                color="black" 
                square
                class="q-px-xl"
                target="_blank" 
                :href="brandConfig.brandSiteUrl" 
              />
            </div>
          </Transition>
        </q-card-section>

        <q-card-section class="text-center vch-footer">
          <div class="vch-legal-text text-grey-8">
            <p>*O benefício de aniversário é válido durante o mês de aniversário,</p>
            <p>com restrição a 1 compra com no máximo 3 produtos.</p>
            <p>O benefício é renovado a cada aniversário.</p>
            <p>Confira sua pasta de SPAM (ou lixo eletrônico).</p>
            <p class="q-pt-lg text-weight-bold text-black prohibition">
              Por se tratar de um beneficio exclusivo é expressamente proibido o
              compartilhamento do CPF e/ou o código do cupom-desconto com outros usuários.
            </p>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { brandConfig } from '@/helpers/brandConfig'

export default {
  name: 'Voucher',
  data: () => ({
    cpf: '',
    isLoading: false,
    brandConfig: brandConfig,
  }),
  computed: {
    ...mapGetters('voucher', ['employee', 'showDialog']),
    ...mapGetters('alert', ['getAlert']),    
  },
  methods: {
    ...mapActions('voucher', ['EmployeeProfile']),
    ...mapActions('alert', ['setAlert', 'dropAlert']),
    handleConfirm() {
      const cleanCpf = this.sanitizeValue(this.cpf);
      if (!this.cpf) {
        this.setAlert({ message: 'Campo CPF é obrigatório' });
      } else if (cleanCpf.length < 11) {
        this.setAlert({ message: 'Campo CPF deve ter 11 dígitos' });
      } else {
        this.isLoading = true;
        this.dropAlert();
        this.EmployeeProfile(cleanCpf).finally(() => this.isLoading = false);
      }
    },
    sanitizeValue(value) { return value.replace(/\D/g, '') }
  },
  mounted() {
    if (this.brandConfig && typeof this.brandConfig.brandColor === 'function') {
      const color = this.brandConfig.brandColor();
      document.documentElement.style.setProperty('--theme-color', color);
    }
  }
}
</script>

<style lang="scss" scoped>
.main-screen {
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center center;
  display: flex;
  overflow: hidden;
}

.layout-wrapper {
  @media (min-width: 1024px) {
    justify-content: flex-end;
    padding-right: 120px;    
  }
  @media (max-width: 1023px) {
    justify-content: center;
    padding: 15px;
  }
}

.voucher-box {
  display: flex;
  flex-direction: column;  
  background-color: white;
  width: 100%;
  max-width: 440px;
  @media (min-width: 1024px) { height: 90vh; border-radius: 0; }
  @media (max-width: 1023px) { height: auto; max-height: 96vh; box-shadow: 0 10px 40px rgba(0,0,0,0.5) !important; }

  // Scroll of Card-voucher
  &::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar
  {
    width: 4px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb
  {
    background-color: #000000;
    border: 2px solid #555555;
    border-radius: 10px;
  }
}

.vch-title {
  color: var(--theme-color);
  font-weight: 700;
  font-size: 2.2rem;
  margin-top: 40px;
  @media (max-width: 600px) { font-size: 1.8rem; margin-top: 20px; }
}

.vch-instruction { font-size: 13px; line-height: 1.6; @media (max-width: 600px) { font-size: 12px; } }
.vch-input-line { border-bottom: 1px solid #d9d9d9; &:focus-within { border-bottom: 2px solid var(--theme-color); } }
.vch-btn-confirm { background: black !important; color: white; height: 40px; font-weight: 700; border-radius: 0; margin-top: 20px; }
.vch-legal-text { font-size: 10.5px; line-height: 1.2; p { margin: 0; } }
.prohibition { font-size: 11px; }


.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.7);
}

.vch-footer { padding-bottom: 30px; }
.error-spacer { min-height: 20px; }
.break-all { word-break: break-all; }
</style>